<template>
  <div>
    <i
      class="bx bx-plus-medical"
      style="color:green;cursor:pointer"
      @click="$bvModal.show(personFullName + personUserID + index)"
      >Προσθήκη</i
    >
    <b-modal
      :id="personFullName + personUserID + index"
      title="Προσθήκη Χτυπήματος"
      centered
      hide-footer
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Προσθήκη Χτυπήματος {{ personFullName }}</h4>

            <form
              class="needs-validation"
              @submit.prevent="attendanceCreateSubmit"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="validationCustom01"
                      >Ημερομηνία και Ωρα Χτυπήματος Κάρτας</label
                    >

                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="mt-3">Ημερομηνία</label>
                        <b-form-datepicker
                          :value="computedDate"
                          confirm
                          locale="el"
                          calendarWidth="300"
                          :start-weekday="1"
                          disabled
                        ></b-form-datepicker>
                      </div>
                      <div class="mb-3">
                        <label class="mt-3">Ώρα</label>
                        <date-picker
                          v-model="timestamp"
                          :start-weekday="1"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="hh:mm"
                          calendarWidth="300"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                Ολοκλήρωση
              </button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

import moment from "moment";
import session from "../../../../api/session";
import { eventCreate } from "../../../../eventspy.js";
export default {
  components: {
    DatePicker,
  },
  props: [
    "personFullName",
    "PersonUserId",
    "date",
    "personID",
    "index",
    "workingSchedule",
  ],
  data() {
    return {
      timestamp: "",
      PersonFullName: this.personFullName,
      personUserID: this.PersonUserId,
      personId: this.personId,
      hitDate: null,
    };
  },
  computed: {
    computedDate() {
      return moment(this.date).format("yyyy-MM-DD");
    },
    isNightShifter() {
      if (this.workingSchedule && this.workingSchedule.length > 0) {
        return this.workingSchedule[0].is_night_shift;
      }
      return false;
    },
  },
  methods: {
    processAttendance() {
      const timestampTime = moment(this.timestamp, "HH:mm");
      console.log(timestampTime);
      const workingScheduleStartTime = moment(
        this.workingSchedule[0].start_time,
        "HH:mm"
      );
      const workingScheduleEndTime = moment(
        this.workingSchedule[0].end_time,
        "HH:mm"
      );
      const timeRangeStart = workingScheduleStartTime
        .clone()
        .subtract(1, "hour");

      const timeRangeEnd = workingScheduleEndTime.clone().add(1, "hour");
      let hitDate = null;
      if (
        timestampTime.isSameOrBefore(workingScheduleStartTime) &&
        timestampTime.isSameOrAfter(timeRangeStart)
      ) {
        hitDate = moment(this.date).subtract(1, "day");
      } else if (
        timestampTime.isSameOrAfter(workingScheduleEndTime) &&
        timestampTime.isSameOrBefore(timeRangeEnd)
      ) {
        hitDate = moment(this.date)
          .clone()
          .add(1, "day");
      } else {
        hitDate = moment(this.date).clone();
      }

      return hitDate.format("YYYY-MM-DD");
    },
    async attendanceCreateSubmit() {
      const hitDate = this.processAttendance();
      let fullTimestamp;
      if (this.isNightShifter) {
        fullTimestamp = moment(hitDate + " " + this.timestamp).format();
        const formData = new FormData();
        formData.append("current_date", this.date);
        formData.append("new_hit", fullTimestamp);
        formData.append("person_user_id", this.PersonUserId);
        formData.append("index", this.index);

        await session
          .post("api/reschedule-night-shift/", formData)
          .then((resp) => {
            console.log(resp.data);
            this.$emit("AttendanceCreate");
            this.$bvModal.hide(
              this.personFullName + this.personUserID + this.index
            );
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        fullTimestamp = moment(this.date + " " + this.timestamp).format();
        await session
          .post("api/attendance/create/", {
            timestamp: fullTimestamp,
            punch: 0,
            status: 2,
            user_id: this.PersonUserId,
            device: "ΚΑΤ' ΕΝΤΟΛΗ",
          })
          .then(() => {
            this.$toastr.Add({
              name: "UniqueToastName",
              title: `Ενημέρωση ${this.personFullName}`,
              msg: "Τα χτύπημα του χρήστη προστέθηκε επιτυχώς!",
              style: { backgroundColor: "#4fd69c", width: "550px" },
              progressbar: false,
              timeout: 2000,
            });

            eventCreate(
              `Δημιουργία - ημιτελεις παρουσίες  timestamp: ${fullTimestamp} person:${this.personUserID}, `,
              1
            );
            this.$emit("AttendanceCreate");
            this.$bvModal.hide(
              this.personFullName + this.personUserID + this.index
            );
          })
          .catch((e) => {
            console.log(e);
          });
      }
      console.log(fullTimestamp);
    },
  },
};
</script>
